import { FormDetailDto } from './form-detail-dto.model';
import { EmployeeFormDataDto } from './employee-form-data-dto.model';


export class AllEmployeeFormDataDto implements IAllEmployeeFormDataDto {
    formDetailData!: FormDetailDto[] | undefined;
    employeeFormData!: EmployeeFormDataDto[] | undefined;

    constructor(data?: IAllEmployeeFormDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formDetailData"])) {
                this.formDetailData = [] as any;
                for (let item of _data["formDetailData"])
                    this.formDetailData!.push(FormDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["employeeFormData"])) {
                this.employeeFormData = [] as any;
                for (let item of _data["employeeFormData"])
                    this.employeeFormData!.push(EmployeeFormDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllEmployeeFormDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllEmployeeFormDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formDetailData)) {
            data["formDetailData"] = [];
            for (let item of this.formDetailData)
                data["formDetailData"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeFormData)) {
            data["employeeFormData"] = [];
            for (let item of this.employeeFormData)
                data["employeeFormData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAllEmployeeFormDataDto {
    formDetailData: FormDetailDto[] | undefined;
    employeeFormData: EmployeeFormDataDto[] | undefined;
}

